import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { Capitalize } from "../../Banding/Utilities";
import { OutputConfigSlice } from "../../redux";
import { FetchOutputConfigMapsList } from "../OutputMappingList/Scripts";
import { Actions } from "../OutputMappingButtonsBar/Types";
import { useUser } from "../../../../../AuthContext";
import { OutputMappingPopupView } from "./OutputMappingPopup.view";

/**
 * Responsible for output mapping popup logic
 * @returns output mapping popup logic
 */
export const OutputMappingPopup: React.FC = () => {
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const popupState = outputConfig.selectedOutputMapping;
  const configId = outputConfig.selectedOutputConfig.id;
  const dispatch = useDispatch();
  const { user } =  useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * Action to close popup
   */
  const onClosePopup = (isReloadRequired: boolean): void => {
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping(
      {
        status: false,
        action: Actions.CLOSE,
        band: Actions.EMPTY,
        configMapId: Actions.EMPTY
      }));

    if (isReloadRequired) {
      FetchOutputConfigMapsList(dispatch, translate, configId, env, user?.token);
    }
  };

  return (
    <OutputMappingPopupView
      onClosePopup={onClosePopup}
      isShow={popupState.status}
      action={popupState.action}
      band={Capitalize(popupState.band)}
    />
  );
};
